import styled from 'styled-components';

export const TransparentButton = styled.button`
  background: transparent;
  border: none;
`;
